import * as React from "react";
import type { SVGProps } from "react";
const SvgUserOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 14"
    {...props}
  >
    <path
      stroke="#F7F7F8"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.5 3a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M1 12.412a5 5 0 0 1 10 0A11.96 11.96 0 0 1 6 13.5c-1.784 0-3.477-.39-5-1.088"
    />
  </svg>
);
export default SvgUserOutlined;
